<template>
  <v-card>
    <v-card-title>
      <v-icon left>mdi-routes-clock</v-icon>
      Incoming Materials
      <v-spacer />
      <ProjectMaterialForm :id="id" :is-edit="false"/>
    </v-card-title>
    <v-card-subtitle>
      List of incoming materials. Shipping and QC Team collates this list to track and sort receiving.
    </v-card-subtitle>
    <v-divider />
    <v-list>
      <template v-for="item in materials">
        <v-list-item :key="item.id">
          <v-list-item-icon>
            <v-icon v-if="item.received" color="green">
              check
            </v-icon>
            <v-icon v-else color="red">
              flight_takeoff
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>
              <div v-if="item.received">RECEIVED ON: {{ item.received_on }}</div>
              <div class="caption">SPEC: {{ item.expected_quantity }} - {{ item.notes }}</div>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="d-inline">
            <ProjectMaterialForm :is-edit="true" :id="id" :instance="item">
              <template v-slot:button="{ on }">
                <v-btn icon small v-on="on">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </template>
              <template #title>
                <div>Edit {{ item.name }}</div>
              </template>
            </ProjectMaterialForm>
            <ProjectMaterialDelete :id="item.id" />
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import ProjectMaterialForm from "./ProjectMaterialForm";
import ProjectMaterialDelete from "./ProjectMaterialDelete";
export default {
  name: "ProjectMaterialsCard",
  components: { ProjectMaterialDelete, ProjectMaterialForm },
  props: {
    materials: {
      type: [Array],
      required: true
    },
    id: {
      type: [Number, String],
      required: true
    }
  }
}
</script>
